/** Situações da entidade TabelaPreco */
export interface TabelaPrecoSituacao {
    id: number,
    nome: string;
}

export const tabelaPrecoAtiva: TabelaPrecoSituacao = {id: 1, nome: 'Ativa'};
export const tabelaPrecoInativa: TabelaPrecoSituacao = {id: 2, nome: 'Inativa'};

export const tabelaPrecoSituacoes: TabelaPrecoSituacao[] = [
    tabelaPrecoAtiva,
    tabelaPrecoInativa
];


/** Verifica se a situação da tabela de preço é ativa */
export function isTabelaPrecoSituacaoAtiva(situacao: number): boolean {
    return situacao === tabelaPrecoAtiva.id;
}

/** Verifica se a situação da tabela de preço é inativa */
export function isTabelaPrecoSituacaoInativa(situacao: number): boolean {
    return situacao === tabelaPrecoInativa.id;
}
